import posthog from 'posthog-js';

// Feature flags (PostHog). Keep flag keys here so gates read from one place.
export const PROJECTS_V2_FLAG = 'projects-v2';

// The projects "v2" experience: deliverables + tasks + documents, the redesigned
// project overview, the new project-form fields, and the richer projects rows.
// Everything in that set is gated behind this flag.
export const isProjectsV2Enabled = (): boolean => !!posthog.isFeatureEnabled(PROJECTS_V2_FLAG);

export const INVOICE_WORK_ORDER_CHECK_FLAG = 'invoice-work-order-check';

// The invoice → work order check and everything derived from it: the mismatch confirmation on a
// parsed upload, the comparison table kept on the invoice form, and the "Enrich Data?" asset
// suggestion banner on invoice detail. All three come from one backend payload (`work_order_check`,
// which carries `asset_suggestion` inside it), so one flag covers the set.
//
// This sits on top of the backend's own switches (`openwrench.decisions.invoice.enabled` and
// `.surface_in_response`), which are global config. This flag is what makes a staged, per-company
// rollout possible while those stay on.
//
// Gating the REQUEST matters most: with the flag off the AI forms stop sending `workOrderId` to the
// extraction endpoint, so the backend never runs the decision and no verdict exists to render. The
// banner is gated separately because `assetSuggestion` is persisted on the invoice — without that,
// invoices created while the flag was on would keep offering asset writes after it was turned off.
export const isInvoiceWorkOrderCheckEnabled = (): boolean =>
	!!posthog.isFeatureEnabled(INVOICE_WORK_ORDER_CHECK_FLAG);
